import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import Home from "@/pages/Home";
import Offers from "@/pages/Ofertas";
import Virals from "@/pages/Virals";
import Categories from "@/pages/Categorias";
import CategoryPage from "@/pages/CategoryPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import Favoritos from "@/pages/Favoritos";

// Admin Pages
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminCategories from "@/pages/admin/Categories";
import AdminPlatforms from "@/pages/admin/Platforms";
import AdminLeads from "@/pages/admin/Leads";
import AdminBlog from "@/pages/admin/Blog";
import AdminSettings from "@/pages/admin/Settings";
import AdminTestimonials from "@/pages/admin/Testimonials";
import AdminFAQ from "@/pages/admin/FAQ";
import AdminHome from "@/pages/admin/HomeManager";

// Context
import { AuthProvider } from "@/context/AuthContext";
import { AppDataProvider } from "@/context/AppDataContext";

function App() {
  return (
    <AuthProvider>
      <AppDataProvider>
        <div className="App min-h-screen bg-background">
          <Toaster position="top-right" richColors />
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/ofertas" element={<Offers />} />
              <Route path="/virais" element={<Virals />} />
              <Route path="/categorias" element={<Categories />} />
              <Route path="/categoria/:slug" element={<CategoryPage />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/privacidade" element={<Privacy />} />
              <Route path="/termos" element={<Terms />} />
              <Route path="/favoritos" element={<Favoritos />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/produtos" element={<AdminProducts />} />
              <Route path="/admin/categorias" element={<AdminCategories />} />
              <Route path="/admin/plataformas" element={<AdminPlatforms />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
              <Route path="/admin/blog" element={<AdminBlog />} />
              <Route path="/admin/configuracoes" element={<AdminSettings />} />
              <Route path="/admin/depoimentos" element={<AdminTestimonials />} />
              <Route path="/admin/faq" element={<AdminFAQ />} />
              <Route path="/admin/home" element={<AdminHome />} />
              
              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </div>
      </AppDataProvider>
    </AuthProvider>
  );
}

export default App;
